<template>
  <div class="profile-widget" @click="onClick">
    <div class="profile-image" v-if="file_name" :title="title">
      <img
        :style="{
          width: size + 'px',
          height: size + 'px',
        }"
        :src="path + file_name"
      />
    </div>
    <div
      class="profile-alphabet"
      :title="title"
      :style="{
        width: parseInt(size) + 'px',
        height: parseInt(size) + 'px',
      }"
      :class="{ margin_right: enableRightMargin }"
      v-else-if="$validateString(title) && $validateString(title) != ' '"
    >
      <span
        :style="{
          fontSize: parseInt(text_size) + 'px',
        }"
        >{{ $nameInitials(title) }}</span
      >
    </div>
    <div class="profile-widget-content" v-if="show_name && showContent">
      <span class="title" v-if="title">
        {{ $validateString(title) }}
      </span>
      <span class="subtitle" v-if="subtitle">
        {{ subtitle }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "widget-profile-viewer",
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    file_name: {
      type: String,
      default: "",
    },
    path: {
      type: String,
      default: "",
    },
    show_name: {
      type: Boolean,
      default: true,
    },
    size: {
      type: Number,
      default: 35,
    },
    text_size: {
      type: Number,
      default: 14,
    },
    showContent: {
      type: Boolean,
      default: true,
    },
    enableRightMargin: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {
    $validateString(val) {
      return val.replaceAll("null", "");
    },
    onClick(e) {
      let vm = this;
      vm.$emit("click", e);
    },
  },
};
</script>
<style lang="scss" scoped>
.profile-widget {
  display: flex;
  align-items: center;

  .profile-alphabet {
    height: 35px;
    width: 35px;
    background: #0884af;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 13px;
    font-weight: 800;
    &.margin_right {
      margin-right: 16px;
    }
  }

  .profile-image {
    img {
      height: 35px;
      width: 35px;
      background: #1ba5a438;
      border-radius: 50%;
      margin-right: 16px;
    }
  }

  .profile-widget-content {
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    min-width: 123px;
    max-width: 180px;
    .title {
      color: #000000;
      font-weight: 600;
      font-size: 15px;
      overflow: hidden;
      text-decoration: none;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .subtitle {
      color: #636363;
      font-size: 13px;
      overflow: hidden;
      text-decoration: none;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  &.active {
    .profile-alphabet {
      background: #fff;
      border: 1px solid #0884af;
      color: #0884af;
    }
  }
}
</style>
